export default __webpack_public_path__ + "5b234ee5752caae787971288c9244928.png";